import React from 'react';
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import DataTable from "../../components/data-table/DataTable";
import {getHumanEmployees, getJuridicalPersons, getExternalSubjects, getCheckingAccounts} from "../../services/organization";
import ActionButton from "../../components/button/ActionButton";
import messageDialogActions from '../../components/dialogs/messageDialog-acions';
import {connect} from "react-redux";
import {
    getDebts, getSpendingTypes,
    navLinks,
    debtLevels,
    debtPaymentTypes,
    createMassDealForDebts
} from "../../services/moneyFlow";
import DatePeriodField from "../../components/fields/DatePeriodField";
import moment from "moment";
import AnyField from "../../components/fields/AnyField";
import infoActions from "../../components/info/info-actions";
import {withTranslation} from "react-i18next";
import _ from "lodash";
import XLSX from "xlsx";
import SelectFromItemsField from "../../components/fields/SelectFromItemsField";
import {processMomentFieldInObject} from "../../utils/moment-utils";
import CheckboxField from "../../components/fields/CheckboxField";
import {getBusinessUnitByRole, hasRole} from "../../services/user";
import MultiSelectFromItemsField from "../../components/fields/MultiSelectFromItemsField";
import DateMonthField from "../../components/fields/DateMonthField";
import {
    FormControl, FormControlLabel, Radio, RadioGroup, 
    Dialog, DialogTitle, DialogContent, DialogActions, 
    Button, MenuItem, Grid, LinearProgress, CircularProgress
} from "@material-ui/core";
import AutocompleteMultiSelectField from "../../components/fields/AutocompleteMultiSelectField";
import AutocompleteSelectField from "../../components/fields/AutocompleteSelectField";
import DateTimeField from "../../components/fields/DateTimeField";
import {getPaymentTypes} from "../../services/sale";


export default
@connect(state => ({
    currentParlour: state.common.currentParlour,
}),{
    showInfo: infoActions.show,
    showMessage: messageDialogActions.show,
})
@withTranslation()
class DebtListPage extends React.Component {
    state = {
        search: {
            search: null,
            date_start: null,
            date_end: null,
            month: null,
            dateType: 'period',
            businessUnitIds: [],
            employeeId: null,
            spendingTypesIds: [],
            unpaid: false,
            lvl: [],
            juridicalPersonIds: [],
            paymentTypes:[],
        },
        refreshTable: false,
        businessUnits: [],
        employees: [],
        spendingTypes: [],
        juridicalPersons: [],
        externalSubjects: [],
        paymentTypes: [],
        companyEmployees: [],
        selectedDebts: [],
        isMassWriteOffModalOpen: false,
        massWriteOffParams: {
            employeeId: null,
            externalSubjectId: null,
            companyEmployeeId: null,
            cancellationFact: null,
            juridicalPersonId: null,
            checkingAccountId: null,
            paymentType: 'cashless'
        },
        dealCheckingAccounts: [],
        page: 0,
        isMassWriteOffInProgress: false, // новое состояние для отслеживания процесса
    };

    columnData = [
        { id: 'amountFormat', label: 'Sum' },
        { id: 'applyAt', label: 'Debt apply', dateFormat: 'MMMM YYYY' },
        { id: 'businessUnitName', label: 'Business unit' },
        { id: 'currentAmountFormat', label: 'Current sum' },
        { id: 'reasonName', label: 'Debt name' },
        { id: 'lvl', label: 'Level' },
        { id: 'juridicalPersonName', label: 'Juridical person' },
        { id: 'comment', label: 'Comment',disableSorting:true },
        { id: 'createdAt', label: 'Created', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
        { id: 'creatorName', label: 'Creator' },
    ];

    columnDataXlsx = [
        { id: 'amount.val', label: 'Sum' },
        { id: 'applyAt', label: 'Debt apply', dateFormat: 'MMMM YYYY' },
        { id: 'businessUnitName', label: 'Business unit' },
        { id: 'currentAmount.val', label: 'Current sum' },
        { id: 'reasonName', label: 'Debt name' },
        { id: 'juridicalPersonName', label: 'Juridical person' },
        { id: 'comment', label: 'Comment' },
        { id: 'createdAt', label: 'Created', dateFormat: 'DD.MM.YYYY HH:mm:ss' },
        { id: 'creatorName', label: 'Creator' },
    ];

    componentDidMount() {
        getBusinessUnitByRole('ROLE_MONEYFLOW_DEBT_GET')
            .then(response => {
                if (response.success) {
                    this.setState({
                        businessUnits: response.data
                    });
                }
            });

        getHumanEmployees({'canHaveMoney': true})
            .then(response => {
                if (response.success) {
                    this.setState({
                        employees: response.data,
                    });
                }
            });

        getSpendingTypes({showInactive: 1})
            .then(response => {
                if (response.success) {
                    this.setState({
                        spendingTypes: response.data
                    });
                }
            });
        
        getJuridicalPersons()
            .then(response=>{
                if(response.success){
                    this.setState({
                        juridicalPersons: response.data,
                    });
                }
            });

        getExternalSubjects()
            .then(response => {
                if (response.success) {
                    this.setState({
                        externalSubjects: response.data,
                    });
                }
            });

        getPaymentTypes().then(response => {
            if (response.success) {
                this.setState({
                    paymentTypes: _.filter(response.data, function(o) {
                        return debtPaymentTypes.includes(o.id);
                    })
                });
            }
        });

        getHumanEmployees()
            .then(response => {
                if (response.success) {
                    this.setState({
                        companyEmployees: response.data,
                    });
                }
            });
    }

    handleSelect = (selected) => {
        this.setState({ selectedDebts: selected });
    };

    handleOpenMassWriteOffModal = () => {
        this.setState({ isMassWriteOffModalOpen: true });
    };

    handleCloseMassWriteOffModal = () => {
        if (this.state.isMassWriteOffInProgress) return; // Не закрывать во время выполнения
        
        this.setState({ 
            isMassWriteOffModalOpen: false,
            massWriteOffParams: {
                employeeId: null,
                externalSubjectId: null,
                companyEmployeeId: null,
                cancellationFact: null,
                juridicalPersonId: null,
                checkingAccountId: null,
                paymentType: null
            },
            dealCheckingAccounts: []
        });
    };

    handleMassWriteOffParamChange = prop => event => {
        let value;

        if (event instanceof moment) {
            value = event;
        } else if (event.target && event.target.value !== undefined) {
            value = event.target.value;
        } else {
            value = event;
        }

        this.setState({
            massWriteOffParams: {
                ...this.state.massWriteOffParams,
                [prop]: value,
            }
        }, () => {
            if (prop === 'juridicalPersonId') {
                this.fetchDealCheckingAccounts();
            }
        });
    };

    fetchDealCheckingAccounts = () => {
        const { massWriteOffParams } = this.state;

        if (massWriteOffParams.juridicalPersonId) {
            getCheckingAccounts({juridicalPersonId: massWriteOffParams.juridicalPersonId, active: true})
                .then((response) => {
                    this.setState({
                        dealCheckingAccounts: response.data || [],
                    });
                });
        } else {
            this.setState({ dealCheckingAccounts: [] });
        }
    };

handleMassWriteOffSubmit = () => {
    const { selectedDebts, massWriteOffParams } = this.state;
    const { t } = this.props;

    // Устанавливаем флаг процесса
    this.setState({ isMassWriteOffInProgress: true });

    // Валидация параметров
    if (!massWriteOffParams.paymentType) {
        this.props.showMessage(t("Тип оплаты обязателен"));
        return;
    }

    if (!massWriteOffParams.juridicalPersonId) {
        this.props.showMessage(t("Юридическое лицо обязательно"));
        return;
    }

    if (massWriteOffParams.paymentType === 'cashless') {
        if (!massWriteOffParams.externalSubjectId) {
            this.props.showMessage(t("Внешний субъект обязателен для безналичной оплаты"));
            return;
        }
        if (!massWriteOffParams.checkingAccountId) {
            this.props.showMessage(t("Расчетный счет обязателен для безналичной оплаты"));
            return;
        }
    }

    if (massWriteOffParams.paymentType === 'cash' && hasRole('ROLE_MONEYFLOW_DEAL_SPENDINGFROMEMPLOYEE') && !massWriteOffParams.employeeId) {
        this.props.showMessage(t("Сотрудник обязателен для наличной оплаты"));
        return;
    }

    if (!massWriteOffParams.cancellationFact) {
        this.props.showMessage(t("Факт списания обязателен"));
        return;
    }

    // Фильтруем долги с положительной суммой
    const nonZeroDebts = selectedDebts.filter(debt => debt.currentAmount.val > 0);
    if (nonZeroDebts.length === 0) {
        this.props.showMessage(t("Нет долгов с положительной суммой для списания"));
        this.setState({ isMassWriteOffInProgress: false });
        return;
    }

    // Для каждого выбранного долга создаем сделку
const dealParamsArray = nonZeroDebts.map(debt => ({
        ...massWriteOffParams,
        amount: { ...debt.currentAmount },
        debtId: debt.id,
        // Используем значения из модального окна, если они заданы, иначе из долга
        employeeId: massWriteOffParams.employeeId !== null ? massWriteOffParams.employeeId : debt.employeeId,
        externalSubjectId: massWriteOffParams.externalSubjectId !== null ? massWriteOffParams.externalSubjectId : debt.externalSubjectId,
        companyEmployeeId: massWriteOffParams.companyEmployeeId !== null ? massWriteOffParams.companyEmployeeId : debt.companyEmployeeId,
        juridicalPersonId: massWriteOffParams.juridicalPersonId !== null ? massWriteOffParams.juridicalPersonId : debt.juridicalPersonId
    }));
    
   createMassDealForDebts(dealParamsArray)
        .then(response => {
            if (response.success) {
                const successfulCount = response.data.successful.length;
                const failedCount = response.data.failed.length;
                
                let message = '';
                
                if (successfulCount > 0) {
                    const totalAmount = response.data.successful.reduce((sum, item) => sum + item.amount, 0);
                    message += `Успешно списано: ${successfulCount} долг(ов) на сумму ${totalAmount.toFixed(2)} руб.`;
                }
                
                if (failedCount > 0) {
                    if (message.length > 0) message += "\n";
                    const totalAmount = response.data.failed.reduce((sum, item) => sum + item.amount, 0);
                    message += `Не удалось списать: ${failedCount} долг(ов) на сумму ${totalAmount.toFixed(2)} руб.`;
                    
                    // Добавляем детали ошибок
                    const errorGroups = {};
                    response.data.failed.forEach(item => {
                        if (!errorGroups[item.error]) {
                            errorGroups[item.error] = {
                                count: 0,
                                totalAmount: 0
                            };
                        }
                        errorGroups[item.error].count += 1;
                        errorGroups[item.error].totalAmount += item.amount;
                    });
                    
                    message += "\n\n" + t("Детали ошибок:") + "\n";
                    Object.keys(errorGroups).forEach(error => {
                        const group = errorGroups[error];
                        message += `• ${error}: ${group.count} долгов на сумму ${group.totalAmount.toFixed(2)} руб.\n`;
                    });
                }
                
                this.props.showMessage(message);
                
                this.setState({ 
                    selectedDebts: [],
                    isMassWriteOffModalOpen: false,
                    isMassWriteOffInProgress: false
                });
                // Обновляем таблицу
                this.setState(prevState => ({ refreshTable: !prevState.refreshTable }));
                } else {
                    this.props.showMessage(response.error);
                    this.setState({ isMassWriteOffInProgress: false });
                }
            })
            .catch(error => {
                this.props.showMessage(t("Ошибка при списании долгов"));
                this.setState({ isMassWriteOffInProgress: false });
            });
};

    handleChange = prop => event => {
        let value;

        if (event instanceof moment) {
            value = event;
        } else {
            value = event.target.value;
        }

        this.setState({
            search: {
                ...this.state.search,
                [prop]: value,
            }
        });
    };

    handleClickFilter = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    getTableData = (...params) => {
        const { search } = this.state;
        return getDebts(processMomentFieldInObject({
            ...search,
            date_start: search.date_start ? search.date_start.startOf('day') : null,
            date_end: search.date_end ? search.date_end.endOf('day') : null,
        }, ['date_start', 'date_end', 'month'],null), ...params);
    };

    handleExport = () => {
        const { t } = this.props;
        const { search, businessUnits } = this.state;
        const from = search.date_start || '';
        const to = search.date_end || '';
        const bu = search.businessUnitIds.length ? search.businessUnitIds.map(id => businessUnits.find(item => item.id === id).name).join(', ') : 'All';

        this.getTableData(1, -1)
            .then(response => {
                if (response.success) {
                    const data = [
                        //First row - headers
                        this.columnDataXlsx.map(item => t(item.label)),
                    ];

                    response.data.forEach(row => {
                        data.push(
                            this.columnDataXlsx.map(item => _.get(row, item.id))
                        );
                    });

                    const worksheet = XLSX.utils.aoa_to_sheet(data);
                    const new_workbook = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(new_workbook, worksheet, "Deals");
                    XLSX.writeFile(new_workbook, `Debts ${bu} ${from} - ${to}.xlsx`);
                } else {
                    this.props.showMessage(response.error ? response.error.message : response.message);
                }
            });
    };

    handleCreate = () => {
        this.props.history.push(`/money-flow/debt/0`);
    };

    render() {
        const { t } = this.props;
        const { 
            refreshTable, search, businessUnits, employees, spendingTypes, juridicalPersons, 
            selectedDebts, isMassWriteOffModalOpen, massWriteOffParams, dealCheckingAccounts,
            externalSubjects, paymentTypes, companyEmployees, isMassWriteOffInProgress
        } = this.state;

        // Проверка условий для кнопки списания в модальном окне
        const massWriteOffDisabled = 
            !massWriteOffParams.paymentType ||
            !massWriteOffParams.juridicalPersonId ||
            (massWriteOffParams.paymentType === 'cashless' && (!massWriteOffParams.externalSubjectId || !massWriteOffParams.checkingAccountId)) ||
            (massWriteOffParams.paymentType === 'cash' && hasRole('ROLE_MONEYFLOW_DEAL_SPENDINGFROMEMPLOYEE') && !massWriteOffParams.employeeId) ||
            !massWriteOffParams.cancellationFact;

        return(
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>

                    <FormControl component="fieldset" fullWidth>
                        <RadioGroup
                            value={search.dateType}
                            onChange={this.handleChange('dateType')}
                            row
                        >
                            <FormControlLabel control={<Radio/>} value="period" label="за период" />
                            <FormControlLabel control={<Radio/>} value="month" label="за месяц"/>
                        </RadioGroup>
                    </FormControl>

                    {search.dateType === 'period' ?
                        <DatePeriodField
                            valueFrom={search.date_start}
                            valueTo={search.date_end}
                            onChangeFrom={this.handleChange('date_start')}
                            onChangeTo={this.handleChange('date_end')}
                            label={t("Show debts by date interval")}
                            required={false}
                        /> :
                        <DateMonthField
                            value={search.month}
                            onChange={this.handleChange('month')}
                            fullWidth
                        />
                    }
                    <AutocompleteMultiSelectField
                        options={businessUnits}
                        label={t("Business unit")}
                        value={search.businessUnitIds}
                        onChange={this.handleChange('businessUnitIds')}
                        fullWidth
                    />
                    <SelectFromItemsField
                        items={employees}
                        label={t("Employee")}
                        value={search.employeeId}
                        onChange={this.handleChange('employeeId')}
                        fullWidth
                        nullable
                        nullableText="Все"
                    />
                    <MultiSelectFromItemsField
                        items={debtLevels}
                        emptySelectedLabel="---Не выбрано---"
                        label={t('Level')}
                        value={search.lvl}
                        onChange={this.handleChange('lvl')}
                        fullWidth
                    />
                    <AutocompleteMultiSelectField
                        label={t('Spending type')}
                        value={search.spendingTypesIds}
                        name="spendingTypesIds"
                        onChange={this.handleChange('spendingTypesIds')}
                        fullWidth
                        options={spendingTypes}
                        placeholder={t('---All---')}
                        valueField="id"
                        textField="name"
                    />
                    <AnyField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        fullWidth
                        label={t("Search")}
                    />
                    <AutocompleteMultiSelectField
                        label={t('Juridical persons')}
                        value={search.juridicalPersonIds}
                        name="juridicalPersonIds"
                        onChange={this.handleChange('juridicalPersonIds')}
                        fullWidth
                        options={juridicalPersons}
                        placeholder={t('---All---')}
                        textField="shortName"
                    />
                    <MultiSelectFromItemsField
                        items={[
                            {'id': 'cash', 'name': t('pay.types.cash')},
                            {'id': 'cashless', 'name': t('pay.types.cashless')},
                            {'id':'checking_account', 'name':t('pay.types.checking_account')}
                        ]}
                        emptySelectedLabel="---Все типы оплаты---"
                        label={t('Payment type')}
                        value={search.paymentTypes}
                        onChange={this.handleChange('paymentTypes')}
                        fullWidth
                    />

                    <CheckboxField
                        label={t("Unpaid debts")}
                        value={search.unpaid}
                        onChange={this.handleChange('unpaid')}
                    />
                    <ActionButton onClick={this.handleClickFilter}>{t("Filter")}</ActionButton>
                    <ActionButton onClick={this.handleExport}>Excel</ActionButton>
                    <ActionButton onClick={this.handleCreate} visible={hasRole('ROLE_MONEYFLOW_DEBT_SAVE')}>{t("Create debt")}</ActionButton>
                    
                    {/* Кнопка массового списания - всегда активна */}
                    <ActionButton 
                        onClick={this.handleOpenMassWriteOffModal} 
                        visible={hasRole('ROLE_MONEYFLOW_DEBT_WRITEOFF')}
                    >
                        {t("Списать выбранные долги")}
                    </ActionButton>
                </LeftBar>
                <Content title={t("Debts")}>
                    <DataTable
                        columnData={this.columnData}
                        dataFunc={this.getTableData}
                        refresh={refreshTable}
                        selector={true}
                        onSelect={this.handleSelect}
                        linkTemplate={ (row) => `/money-flow/debt/id/` + row.id }
                        order="desc"
                        orderBy="createdAt"
                    />
                </Content>

                {/* Модальное окно массового списания */}
                <Dialog
                    open={isMassWriteOffModalOpen}
                    onClose={isMassWriteOffInProgress ? undefined : this.handleCloseMassWriteOffModal}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle>
                        {t('Массовое списание долгов')}
                        {isMassWriteOffInProgress && (
                            <span style={{marginLeft: '10px', color: '#2196f3'}}>
                                {t('Идет обработка...')}
                            </span>
                        )}
                    </DialogTitle>
                    <DialogContent style={{minHeight: 500}}>
                        {/* Индикатор прогресса */}
                        {isMassWriteOffInProgress && (
                            <div style={{position: 'absolute', top: 0, left: 0, right: 0}}>
                                <LinearProgress />
                            </div>
                        )}
                        
                        <div style={{
                            marginBottom: '16px', 
                            padding: '8px', 
                            backgroundColor: '#f5f5f5', 
                            borderRadius: '4px',
                            opacity: isMassWriteOffInProgress ? 0.5 : 1
                        }}>
                            <strong>Выбрано долгов: {selectedDebts.length}</strong>
                            <br />
                            <small>Общая сумма: {selectedDebts.reduce((sum, debt) => sum + (debt.currentAmount?.val || 0), 0)}</small>
                        </div>
                        
                        <Grid container spacing={2} style={{opacity: isMassWriteOffInProgress ? 0.5 : 1}}>
                            <Grid item xs={6}>
                                <AnyField
                                    value={massWriteOffParams.paymentType}
                                    error={!massWriteOffParams.paymentType}
                                    onChange={this.handleMassWriteOffParamChange('paymentType')}
                                    select
                                    label={t("Payment type")}
                                    required
                                    fullWidth
                                    disabled={isMassWriteOffInProgress}
                                >
                                    {paymentTypes.map(item => 
                                        <MenuItem key={item.id} value={item.id}>{item.text}</MenuItem>
                                    )}
                                </AnyField>
                            </Grid>
                            <Grid item xs={6}>
                                <AutocompleteSelectField
                                    label={t("Juridical person")}
                                    value={massWriteOffParams.juridicalPersonId}
                                    required
                                    error={!massWriteOffParams.juridicalPersonId}
                                    onChange={this.handleMassWriteOffParamChange('juridicalPersonId')}
                                    fullWidth
                                    options={juridicalPersons.map(item => ({value: item.id, label: `${item.shortName}`}))}
                                    disabled={isMassWriteOffInProgress}
                                />
                            </Grid>
                            
                            <Grid item xs={6}>
                                <AutocompleteSelectField
                                    label={t("External subject")}
                                    value={massWriteOffParams.externalSubjectId}
                                    required={massWriteOffParams.paymentType === 'cashless'}
                                    error={massWriteOffParams.paymentType === 'cashless' && !massWriteOffParams.externalSubjectId}
                                    onChange={this.handleMassWriteOffParamChange('externalSubjectId')}
                                    fullWidth
                                    options={externalSubjects.map(item => ({value: item.id, label: `${item.name}`}))}
                                    disabled={isMassWriteOffInProgress}
                                />
                            </Grid>

                            {massWriteOffParams.paymentType === 'cashless' && (
                                <Grid item xs={6}>
                                    <AutocompleteSelectField
                                        label={t("Checking account")}
                                        value={massWriteOffParams.checkingAccountId}
                                        required
                                        error={!massWriteOffParams.checkingAccountId}
                                        onChange={this.handleMassWriteOffParamChange('checkingAccountId')}
                                        fullWidth
                                        options={dealCheckingAccounts.map(item => ({value: item.id, label: `${item.bankName + ' / ' + item.juridicalPersonShortName}`}))}
                                        disabled={isMassWriteOffInProgress}
                                    />
                                </Grid>
                            )}
                            {massWriteOffParams.paymentType === 'cash' && hasRole('ROLE_MONEYFLOW_DEAL_SPENDINGFROMEMPLOYEE') && (
                                <Grid item xs={6}>
                                    <SelectFromItemsField
                                        label={t("Write off from")}
                                        value={massWriteOffParams.employeeId}
                                        onChange={this.handleMassWriteOffParamChange('employeeId')}
                                        fullWidth
                                        required
                                        error={!massWriteOffParams.employeeId}
                                        items={[
                                            { id: -1, name: t("Business unit cashbox")},
                                            ...employees
                                        ]}
                                        disabled={isMassWriteOffInProgress}
                                    />
                                </Grid>
                            )}
                            <Grid item xs={6}>
                                <AutocompleteSelectField
                                    label={t('Company employee')}
                                    value={massWriteOffParams.companyEmployeeId}
                                    onChange={this.handleMassWriteOffParamChange('companyEmployeeId')}
                                    fullWidth
                                    options={companyEmployees.map(item => ({value: item.id, label: `${item.name}`}))}
                                    disabled={isMassWriteOffInProgress}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <DateTimeField
                                    label={t("Cancellation fact")}
                                    value={massWriteOffParams.cancellationFact}
                                    fullWidth
                                    required
                                    onChange={this.handleMassWriteOffParamChange('cancellationFact')}
                                    disabled={isMassWriteOffInProgress}
                                    error={!massWriteOffParams.cancellationFact}
                                />
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button 
                            onClick={this.handleCloseMassWriteOffModal} 
                            disabled={isMassWriteOffInProgress}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button 
                            onClick={this.handleMassWriteOffSubmit} 
                            color="primary"
                            disabled={massWriteOffDisabled || isMassWriteOffInProgress}
                            startIcon={isMassWriteOffInProgress ? <CircularProgress size={16} /> : null}
                        >
                            {isMassWriteOffInProgress ? t('Списание...') : t('Списать')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}